export var CustomPDFReportCreateOption;
(function (CustomPDFReportCreateOption) {
    CustomPDFReportCreateOption["BLANK_REPORT"] = "blank_report";
    CustomPDFReportCreateOption["NEW_FROM_TEMPLATE"] = "new_from_template";
})(CustomPDFReportCreateOption || (CustomPDFReportCreateOption = {}));
export var CustomPDFReportSaveOption;
(function (CustomPDFReportSaveOption) {
    CustomPDFReportSaveOption["SAVE"] = "save";
    CustomPDFReportSaveOption["SAVE_AS"] = "save_as";
})(CustomPDFReportSaveOption || (CustomPDFReportSaveOption = {}));
export var CustomPDFReportTabDropdownOption;
(function (CustomPDFReportTabDropdownOption) {
    CustomPDFReportTabDropdownOption["NEW_FROM_TEMPLATE"] = "newFromTemplateReport";
    CustomPDFReportTabDropdownOption["OPEN"] = "openReport";
    CustomPDFReportTabDropdownOption["REPORT_SETTINGS"] = "openReportSettings";
    CustomPDFReportTabDropdownOption["CLOSE"] = "closeReport";
    CustomPDFReportTabDropdownOption["DELETE"] = "deleteReport";
    CustomPDFReportTabDropdownOption["RENAME"] = "renameReport";
    CustomPDFReportTabDropdownOption["SAVE_AS"] = "saveAsReport";
    CustomPDFReportTabDropdownOption["SAVE"] = "saveReport";
})(CustomPDFReportTabDropdownOption || (CustomPDFReportTabDropdownOption = {}));
export var CustomPDFReportModuleDropdownOption;
(function (CustomPDFReportModuleDropdownOption) {
    CustomPDFReportModuleDropdownOption["ADD_TO_SECTION"] = "addToSection";
    CustomPDFReportModuleDropdownOption["DUPLICATE"] = "duplicateModule";
    CustomPDFReportModuleDropdownOption["CREATE_SECTION"] = "createSection";
    CustomPDFReportModuleDropdownOption["REMOVE_FROM_SECTION"] = "removeFromSection";
    CustomPDFReportModuleDropdownOption["SAVED_ASSET_OPTIONS"] = "SavedAssetOptions";
})(CustomPDFReportModuleDropdownOption || (CustomPDFReportModuleDropdownOption = {}));
